import { render, staticRenderFns } from "./SpeakerListItem.vue?vue&type=template&id=2313164d&scoped=true&"
import script from "./SpeakerListItem.vue?vue&type=script&lang=js&"
export * from "./SpeakerListItem.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerListItem.vue?vue&type=style&index=0&id=2313164d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2313164d",
  null
  
)

export default component.exports